import type { DefaultConfigOptions } from '@formkit/vue'
import { generateClasses } from '@formkit/themes'
import { de, en, es, fr } from '@formkit/i18n'
import { createAutoAnimatePlugin } from '@formkit/addons'
import { inputs } from '@daysmart/daysmart-vue-components/formkit'
import { requiredAsterisk } from '@daysmart/daysmart-vue-components/formkit/plugins'

import theme from './src/core/theme/formkit'

const config: DefaultConfigOptions = {
  // locales
  locales: { en, fr, de, es },
  locale: 'en',
  // icons
  inputs,
  plugins: [
    createAutoAnimatePlugin(),
    requiredAsterisk,
  ],
  // config
  config: {
    classes: generateClasses(theme),
  },
}

export default config
